import avatarModule from '../avatarModule';

function emotesModalController(
  $scope,
  $uibModalInstance,
  $log,
  modalData,
  avatarService,
  avatarConstantService,
  avatarTypeService,
  thumbnailConstants
) {
  'ngInject';

  $scope.emotesModalData = modalData;
  $scope.systemFeedback = modalData.systemFeedback;

  const emoteConstants = avatarConstantService.emotes;
  const numberOfEmotePositions = 8;

  $scope.radialSlices = {};

  $scope.isRequestDelete = false;
  $scope.selectedAssetId = !modalData.selectedItem ? null : modalData.selectedItem.id;
  $scope.selectedPositionIndex = null;
  $scope.hoveredPositionIndex = null;

  // Grid functions
  $scope.addItemThumbnailAndLink = modalData.addItemThumbnailAndLink;
  $scope.systemFeedback = modalData.systemFeedback;

  $scope.getAssetTypeByName = avatarTypeService.getAssetTypeByName;
  $scope.getAssetTypeName = avatarTypeService.getAssetTypeName;

  $scope.thumbnailTypes = thumbnailConstants.thumbnailTypes;

  function deselectAll() {
    $scope.selectedAssetId = null;
    $scope.hoveredPositionIndex = null;
    $scope.selectedPositionIndex = null;
    $scope.isRequestDelete = false;
  }

  $scope.init = function() {
    // Get all equipped emotes
    avatarService.getEmotes().then(
      function success(data) {
        // Make positions with emotes in them
        for (let i = 0; i < data.length; i++) {
          const positionIndex = data[i].position;
          const { assetId } = data[i];
          $scope.radialSlices[positionIndex] = {
            isEmpty: false,
            position: positionIndex,
            assetId
          };
        }

        // Fill empty positions
        for (let j = 1; j <= numberOfEmotePositions; j++) {
          if ($scope.radialSlices[j] === null || $scope.radialSlices[j] === undefined) {
            $scope.radialSlices[j] = {
              isEmpty: true,
              position: j,
              assetId: null
            };
          }
        }
      },
      function error(data) {
        $scope.systemFeedback.error(emoteConstants.errorGettingEmotes);
      }
    );
  };

  function equipEmote(assetId, positionIndex) {
    avatarService.equipEmote(assetId, positionIndex).then(
      function success() {
        $log.debug('Updated emote');
        $scope.systemFeedback.success(emoteConstants.successfulUpdate);
        // Add the new position
        $scope.radialSlices[positionIndex] = {
          isEmpty: false,
          position: positionIndex,
          assetId
        };
        deselectAll();
      },
      function error(data) {
        $scope.systemFeedback.error(emoteConstants.errorUpdatingEmote);
      }
    );
  }

  $scope.onEmotesPositionClick = function(positionIndex, isPositionEmpty) {
    if ($scope.selectedAssetId === null) {
      if ($scope.selectedPositionIndex === null || $scope.selectedPositionIndex !== positionIndex) {
        $scope.selectedPositionIndex = positionIndex;
        $scope.isRequestDelete = !isPositionEmpty;
      } else {
        deselectAll();
      }
    } else {
      equipEmote($scope.selectedAssetId, positionIndex);
    }
  };

  $scope.onEmotesCardClick = function(assetId) {
    if ($scope.selectedPositionIndex === null) {
      if ($scope.selectedAssetId === null || $scope.selectedAssetId !== assetId) {
        $scope.selectedAssetId = assetId;
      } else {
        deselectAll();
      }
    } else {
      equipEmote(assetId, $scope.selectedPositionIndex);
    }
  };

  $scope.confirmDelete = function() {
    if ($scope.selectedPositionIndex !== null) {
      avatarService.unequipEmote($scope.selectedPositionIndex).then(
        function success() {
          $log.debug('Deleted emote');
          $scope.systemFeedback.success(emoteConstants.successfulDelete);
          // Clear position
          $scope.radialSlices[$scope.selectedPositionIndex] = {
            isEmpty: true,
            position: $scope.selectedPositionIndex,
            assetId: null
          };
          deselectAll();
        },
        function error(data) {
          $scope.systemFeedback.error(emoteConstants.errorDeletingEmote);
        }
      );
      $scope.isRequestDelete = false;
    }
  };

  $scope.onHoverPosition = function(positionIndex) {
    $scope.hoveredPositionIndex = positionIndex;
  };

  $scope.close = function() {
    $uibModalInstance.dismiss();
  };

  $scope.resetHoveredPosition = function() {
    $scope.hoveredPositionIndex = $scope.selectedPositionIndex;
  };

  $scope.init();
}

avatarModule.controller('emotesModalController', emotesModalController);

export default emotesModalController;
